import React from "react"

const RetinaImageWrapper = ({ image = {}, retinaImage = {}, ...props }) => {
  const { url = null, title = "" } = image || {}
  if (!url) {
    return null
  }
  return <img src={retinaImage?.url || url} alt={title} {...props} />
}

export default RetinaImageWrapper
